"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useEventHandler_1 = require("../utils/useEventHandler");
var NsForm = function (_a) {
    var children = _a.children, onSubmit = _a.onSubmit, onValidated = _a.onValidated, slot = _a.slot;
    var ref = react_1.default.useRef();
    (0, useEventHandler_1.useEventHandler)(ref, 'submit', onSubmit);
    (0, useEventHandler_1.useEventHandler)(ref, 'validated', onValidated);
    return (react_1.default.createElement("ns-form", { slot: slot, ref: ref }, children));
};
exports.default = NsForm;
